import * as firebase from 'firebase';

const config ={  

	apiKey: "AIzaSyDcXvFUo4d8kLaZ4k330uLpeqiCsR5SMQs",
  authDomain: "universia-dev.firebaseapp.com",
  databaseURL: "https://universia-dev.firebaseio.com",
  projectId: "universia-dev",
  storageBucket: "universia-dev.appspot.com",
  messagingSenderId: "363063854822",
  appId: "1:363063854822:web:566b9918df10f742ee5d27",
  measurementId: "G-ZPPECWY6GE"
    
	/*apiKey: "AIzaSyAjQjrBMB73R5afENREDa0En7MnZpewQZ0",
  authDomain: "pieza-development.firebaseapp.com",
  databaseURL: "https://pieza-development.firebaseio.com",
  projectId: "pieza-development",
  storageBucket: "pieza-development.appspot.com",
  messagingSenderId: "10560275828",
  appId: "1:10560275828:web:e7979f61272aaca7cd9821"*/
};

firebase.initializeApp(config);
const database = firebase.firestore();
var storage = firebase.storage();

export { firebase, storage, database as default};